module.exports = __webpack_public_path__ + "fonts/OPPOSans-H.e650e52.woff2";